function ChevronDown(props: iconProps) {
  const fill = props.fill || 'currentColor'
  const strokewidth = props.strokewidth || 2
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'chevron down'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      className={props?.className}
    >
      <title>{title}</title>
      <g fill={fill}>
        <path
          d='M15 18.8787L24 27.8787L33 18.8787L35.1213 21L24 32.1213L12.8787 21L15 18.8787Z'
          fill={fill}
          fillRule='evenodd'
          strokeWidth={strokewidth}
        />
      </g>
    </svg>
  )
}

export default ChevronDown
